import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import NorthEastIcon from '@mui/icons-material/NorthEast';
import GroupedBarLineChart from "../GroupedBarLineChart";
import { getFormatedDate } from "../../../../helper";
import { IconButton } from "@material-ui/core";
import HorizontalBarChart from "../HorizontalBarChart";
import ThresholdInputBox from "../ThresholdInputBox";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import { formatToKOrM } from "../../../../helper";
import BarMultiLineChart from "../BarMultiLineChart";
import { TextField } from "@mui/material";
import TableRowData from "./TableRowData";


const useStyles = makeStyles({
    tableWrapper: {
        overflowY: "auto",
        height: "450px", /* Adjust based on how much content you want visible before scrolling */
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
        fontFamily: "'Arial', sans-serif",
        margin: "20px 0",

    },
    header: {
        position: "sticky",
        top: "0",
        zIndex: "1",
    },
    th: {
        background: "#f7f9fc",
        padding: "10px",
        textAlign: "left",
        fontSize: "14px",
        fontWeight: "bold",
        borderBottom: "1px solid #ddd",
    },
    td: {
        padding: "10px",
        fontSize: "14px",
        borderBottom: "1px solid #ddd",
    },
    editableInput: {
        width: "70px",
        textAlign: "center",
        border: "0.5px solid #0082CA",
        borderRadius: "4px",
        padding: "2px 5px",
        color: "#929497",
        '&::-webkit-outer-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
        },
        '&::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
        },
        '&[type="number"]': {
            MozAppearance: 'textfield', // For Firefox
            MsAppearance: 'textfield',  // For IE/Edge
        },
    },
    chartContainer: {
        display: "flex",
        alignItems: "center",
    },
    chartBar: {
        height: "20px",
        borderRadius: "0px",
        marginRight: "0px",
    },
    chartBarWithBorder: {
        height: "20px",
        borderTopRightRadius: "30px", /* Apply border-radius to the top-right corner */
        borderBottomRightRadius: "30px", /* Apply border-radius to the bottom-right corner */
        marginRight: "0px",
    },
    nestle: { backgroundColor: "#FFD700", width: "40%" },
    baking: { backgroundColor: "#FF6347", width: "20%" },
    infant: { backgroundColor: "#FF69B4", width: "20%" },
    others: { backgroundColor: "#9370DB", width: "20%" },
    label: {
        fontSize: "12px",
        margin: "0 5px",
        color: "#555",
    },
    label_Bold: {
        fontWeight: 'bold'
    },
    withDot: {
        position: 'relative',
    },
    dot: {
        width: 8,
        height: 8,
        borderRadius: '50%',
        marginRight: 8, // Space between dot and label
        display: 'inline-block',
    },
    redDot: {
        backgroundColor: '#FFD700',
    },
    blueDot: {
        backgroundColor: '#FF6347',
    },
    greenDot: {
        backgroundColor: '#FF69B4',
    },
    purpleDot: {
        backgroundColor: '#9370DB',
    },
    closeButton: {
        border: "none",
        background: "#ffffff",
        fontSize: "18px",
        fontWeight: "700",
        cursor: "pointer"
    },
    percentageSign: {
        position: "absolute",
        right: "5px",
        top: "50%",
        transform: "translateY(-50%)",
        pointereEvents: "none", /* Prevents the percentage sign from interfering with input focus */
        fontSize: "16px",
        color: "#929497",
    },
    inputWrapper: {
        position: "relative",
        display: "inline-flex",
        alignItems: "center"
    },
});

const dummyData = [
    {
        category: "Ambient",
        threshold: 100,
        breachStart: "31st Jul",
        breachEnd: "31st Oct",
        utilization: { avg: "108%", max: "123%" },
        palletsBreached: { avg: "13K", max: "22K" },
        avgShare: [74.1, 69.8, 59.6, 144],
    },
    {
        category: "5410",
        threshold: 100,
        breachStart: "NA",
        breachEnd: "NA",
        utilization: { avg: "NA", max: "NA" },
        palletsBreached: { avg: "NA", max: "NA" },
        avgShare: [74.1, 69.8, 59.6, 144],
    },
    {
        category: "5420",
        threshold: 100,
        breachStart: "31st Jul",
        breachEnd: "31st Oct",
        utilization: { avg: "108%", max: "123%" },
        palletsBreached: { avg: "13K", max: "22K" },
        avgShare: [74.1, 69.8, 59.6, 144],
    },
    {
        category: "5620",
        threshold: 100,
        breachStart: "31st Jul",
        breachEnd: "31st Oct",
        utilization: { avg: "108%", max: "123%" },
        palletsBreached: { avg: "13K", max: "22K" },
        avgShare: [74.1, 69.8, 59.6, 144],
    },
];

const dummyGraphData = [
    {
        "Date": "2024-09-24",
        "BookedAppointments": "855",
        "AvailableAppointments": 1303,
        "Utilization": 65.61780506523408
    },
    {
        "Date": "2024-09-25",
        "BookedAppointments": "845",
        "AvailableAppointments": 1297,
        "Utilization": 65.15034695451041
    },
    {
        "Date": "2024-09-26",
        "BookedAppointments": "829",
        "AvailableAppointments": 1294,
        "Utilization": 64.06491499227202
    },
    {
        "Date": "2024-09-27",
        "BookedAppointments": "662",
        "AvailableAppointments": 1204,
        "Utilization": 54.98338870431893
    },
    {
        "Date": "2024-09-28",
        "BookedAppointments": "275",
        "AvailableAppointments": 592.2,
        "Utilization": 46.437014522120904
    },
    {
        "Date": "2024-09-29",
        "BookedAppointments": "247",
        "AvailableAppointments": 581,
        "Utilization": 42.51290877796902
    }
];

const TableWithChart = ({
    activeTab,
    graphData,
    expansionGraphData,
    _showGraph,
    _setShowGraph,
    entityAndThreshold,
    setEntityAndThreshold,
    _updateThreshold,
    setUpdateThreshold,
    entityName,
    setEntityName,
    _currentRowIndex,
    setCurrentRowIndex
}) => {
    const classes = useStyles();
    // const [data, setData] = useState(graphData);
    const [showByPercentage, setShowByPercentage] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const [filterdGraphData, setFilteredGraphdata] = useState([...graphData]);
    const [DCDataList, setDCDataList] = useState([]);
    const [showDcData, setShowDcData] = useState(false);
    const networkOptions = ["AMBIENT", "CHILLED", "FROZEN", "NPW"];


    const handleShowByPercentage = (event) => {
        setShowByPercentage(event.target.checked);
    };

    const handleUpdateThresoldEdited = () => {
        setUpdateThreshold(true);
    };

    const handleRowClick = (row) => {
        const graphDataRowIndex = graphData.map((item, index) => {
            if (item.Entity_name === row?.Entity_name) {
              return index; // Return the index when there's a match
            }
            return null; // Return null (or any placeholder) when there's no match
          }).filter(index => index !== null); // Filter out null values
        setCurrentRowIndex(graphDataRowIndex);
        setEntityName(row?.Entity_name);
    };

    const handleCloseGraph = () => {
        setEntityName("");
    };
    
    const handleSearchValue = (event) => {
        setSearchValue(event.target.value);
    };

    const handleShowDC = (row) =>{
        if(!showDcData){
            const dcData = graphData?.filter(item => item?.Network === row?.Entity_name && item?.Entity_name !== row?.Entity_name);
            setDCDataList([...dcData]);
            setFilteredGraphdata([row]);
            setShowDcData(true);
        }else{
            setShowDcData(false);
            setDCDataList([]);
            setFilteredGraphdata([...graphData]);
        }
       
    };

    useEffect(()=>{
        const filteredData = graphData?.filter((item) => 
            item?.Entity_name?.toLowerCase()?.includes(searchValue?.toLowerCase()) 
        );
        setFilteredGraphdata([...filteredData]);
        setShowDcData(false);
        setDCDataList([]);
    }, [searchValue]);

    return (
        <div className={classes.tableWrapper}>
            <table className={classes.table}>
                <thead className={classes.header}>
                    <tr>
                        <th></th>
                        <th className={classes.th}> 
                            <TextField
                            id="outlined-basic" 
                            size="small"
                            label="" 
                            value={searchValue}
                            variant="outlined" 
                            onChange={handleSearchValue}
                            disabled={entityName ? true : false}
                            placeholder="Search..."
                            sx={{
                                width: "80px",
                                "& .MuiInputBase-root": {
                                    height: "25x", // Adjust height here
                                },
                                "& .MuiInputBase-input": {
                                padding: "5px", // Adjust padding to reduce height further
                                fontSize: "0.75rem", // Optionally reduce font size
                                }

                            }}/>
                            {/* <input type="text" 
                            value={searchValue}
                            width={}
                            onChange={handleSearchValue}/> */}
                        </th>
                        <th className={classes.th}>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div>
                                    Threshold
                                </div>
                                <div style={{ marginLeft: "5px", cursor: "pointer", }}>
                                    <CloudUploadIcon onClick={handleUpdateThresoldEdited} />
                                </div>
                            </div>
                        </th>
                        <th className={classes.th}>Breach Start</th>
                        <th className={classes.th}>Breach End</th>
                        <th className={classes.th}>Utilization</th>
                        <th className={classes.th}>Pallets Breached</th>
                        <th className={classes.th}>
                            <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center" }}>
                                <div>
                                    Avg share by division
                                </div>
                                <div>
                                    <FormControlLabel control={
                                        <Switch
                                            checked={showByPercentage}
                                            onChange={handleShowByPercentage}
                                            inputProps={{ 'aria-label': 'controlled' }}
                                            sx={{
                                                '& .MuiSwitch-switchBase.Mui-checked': {
                                                    color: '#FC6135',
                                                },
                                                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                    backgroundColor: '#FC6135',
                                                }
                                            }}
                                        />} label="By %"
                                    />
                                </div>
                            </div>

                        </th>
                        <th className={classes.th} >

                        </th>
                    </tr>
                </thead>
                <tbody>
                    <TableRowData
                       graphData={graphData}
                       showDcData={showDcData}
                       filterdGraphData={(searchValue || entityName) ? filterdGraphData : filterdGraphData?.filter(item => networkOptions?.includes(item?.Entity_name))}
                       entityName={entityName}
                       showByPercentage={showByPercentage}
                       entityAndThreshold={entityAndThreshold}
                       setEntityAndThreshold={setEntityAndThreshold}
                       handleShowDC={handleShowDC}
                       handleRowClick={handleRowClick}
                       handleCloseGraph={handleCloseGraph}
                    />
                    {/* {filterdGraphData?.length > 0 && filterdGraphData[0]?.hasOwnProperty("1_Division")
                        && filterdGraphData?.map((row, index) => (
                            <tr key={index}>
                                <td
                                    className={classes.td}
                                    style={{ color: '#0067a1', fontWeight: 'bold' }}
                                >{row?.Entity_name}</td>
                                <td className={classes.td}>
                                    <ThresholdInputBox
                                        index={index}
                                        threshold={row?.Threshold}
                                        graphData={graphData}
                                        entityAndThreshold={entityAndThreshold}
                                        setEntityAndThreshold={setEntityAndThreshold}
                                    />
                                    {networkOptions.includes(row.Entity_name) &&
                                        <button
                                        onClick={()=>handleShowDC(row.Entity_name)}
                                        >+</button>
                                    }
                                    
                                </td>
                                <td className={classes.td}>{row?.breach_start_date === "NA" ? "NA" : getFormatedDate(row?.breach_start_date)}</td>
                                <td className={classes.td}>{row?.breach_end_date === "NA" ? "NA" : getFormatedDate(row?.breach_end_date)}</td>
                                <td className={classes.td}>
                                    <div className={classes.chartContainer} style={{ justifyContent: "space-evenly" }}>
                                        <div>Avg</div>
                                        <div>Max</div>
                                    </div>
                                    <div style={{ justifyContent: "space-evenly", display: "flex" }}>
                                        <div className={classes.label_Bold} style={{ marginRight: '15px' }}>{row?.avg_percent_utilized === "NA" ? "NA" : (row?.avg_percent_utilized + "%")}</div>
                                        <div className={classes.label_Bold}>{row?.max_percent_utilized === "NA" ? "NA" : (row?.max_percent_utilized + "%")}</div>
                                    </div>
                                </td>
                                <td className={classes.td}>
                                    <div className={classes.chartContainer} style={{ justifyContent: "space-evenly" }}>
                                        <div>Avg</div>
                                        <div>Max</div>
                                    </div>
                                    <div style={{ justifyContent: "space-evenly", display: "flex" }}>
                                        <div className={classes.label_Bold} style={{ marginRight: '15px' }}>{row?.avg_pallets === "NA" ? "NA" : formatToKOrM(Number(row?.avg_pallets))}</div>
                                        <div className={classes.label_Bold}>{row?.max_pallets === "NA" ? "NA" : formatToKOrM(Number(row?.max_pallets))}</div>
                                    </div>
                                </td>
                                <td className={classes.td}>
                                    {row?.hasOwnProperty("1_Division") && row["1_Division"] !== "NA" ?
                                        <div style={{ minWidth: '24vw', maxWidth:'24vw' }}>
                                            <HorizontalBarChart
                                                item={row}
                                                showByPercentage={showByPercentage} />
                                        </div>
                                        :
                                        <div style={{textAlign: "center"}}>
                                            NA
                                        </div>
                                       
                                    }


                                </td>
                                <td className={classes.td}>
                                    <div style={{ cursor: "pointer" }}>
                                        {!entityName ?
                                            <ExpandMoreIcon
                                                onClick={() => handleRowClick(index)} />
                                            :
                                            <ExpandLessIcon
                                                onClick={handleCloseGraph} />
                                        }
                                    </div>
                                </td>
                            </tr>
                        ))} */}
                        {DCDataList?.length > 0 && showDcData && 
                            <TableRowData
                            graphData={graphData}
                            showDcData={showDcData}
                            filterdGraphData={DCDataList}
                            entityName={entityName}
                            showByPercentage={showByPercentage}
                            entityAndThreshold={entityAndThreshold}
                            setEntityAndThreshold={setEntityAndThreshold}
                            handleShowDC={handleShowDC}
                            handleRowClick={handleRowClick}
                            handleCloseGraph={handleCloseGraph}
                            />
                        }
                </tbody>
            </table>
            {expansionGraphData?.length > 0 && entityName &&
                <BarMultiLineChart
                    graphData={expansionGraphData}
                    activeTab={activeTab} />
            }
          
        </div>
    );
};

export default TableWithChart;
